module.exports = __webpack_public_path__ + "static/media/temperada.d5e266e4.png";